<template>
  <aside class="sidebar">
    <div class="sidebar-header">
      <div class="sidebar-logo">
        <span class="sidebar-title">Menu</span>
      </div>
    </div>
    
    <nav class="sidebar-nav">
      <div class="nav-section" v-if="true">
        <h3 class="nav-section-title">Principal</h3>
        <ul class="nav-list">
          <li v-if="isAllowed('dashboard')">
            <router-link 
              to="/dashboard" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
              </svg>
              <span class="nav-text">Dashboard</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
          <!--          
          <li>
            <router-link 
              to="/apis-old" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              <span class="nav-text">Catálogo de APIs</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
          -->
          <!-- Item "Catálogo de APIs" removido -->
          <li v-if="isAllowed('architecture.products')">
            <router-link 
              to="/architecture/enterprise-architecture" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3,3H11V11H3V3M13,3H21V11H13V3M3,13H11V21H3V13M13,13H21V21H13V13M5,5V9H9V5H5M15,5V9H19V5H15M5,15V19H9V15H5M15,15V19H19V15Z"/>
              </svg>
              <span class="nav-text">Arquitetura Corporativa</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
          <li v-if="isAllowed('docs')">
            <router-link 
              to="/docs" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
              </svg>
              <span class="nav-text">Documentações</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>         
        </ul>
      </div>
      <!-- Arquitetura Empresarial desabilitada -->
      <!--
      <div class="nav-section" v-if="isAllowed('architecture') || isAllowed('architecture.diagrams') || isAllowed('architecture.business') || isAllowed('architecture.application') || isAllowed('architecture.technology')">
        ...
      </div>
      -->
      <!--
      <div v-if="hasArchitectRole" class="nav-section">
        <h3 class="nav-section-title">Arquitetura Empresarial</h3>
        <ul class="nav-list">
          <li>
            <router-link 
              to="/architecture" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12,2L2,7L12,12L22,7L12,2M2,17L12,22L22,17M2,12L12,17L22,12"/>
              </svg>
              <span class="nav-text">Visão Geral</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
          <li>
            <router-link 
              to="/architecture/diagrams" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M2,2V4H20V2H2M4,6V8H18V6H4M6,10V12H16V10H6M8,14V16H14V14H8M10,18V20H12V18H10Z"/>
              </svg>
              <span class="nav-text">Diagramas</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
          <li>
            <router-link 
              to="/architecture/business-old" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12,7V3H2V21H22V7H12M6,19H4V17H6V19M6,15H4V13H6V15M6,11H4V9H6V11M6,7H4V5H6V7M10,19H8V17H10V19M10,15H8V13H10V15M10,11H8V9H10V11M10,7H8V5H10V7M20,19H12V17H20V19M20,15H12V13H20V15M20,11H12V9H20V11Z"/>
              </svg>
              <span class="nav-text">Arquitetura de Negócio</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
          <li>
            <router-link 
              to="/architecture/business" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12,7V3H2V21H22V7H12M6,19H4V17H6V19M6,15H4V13H6V15M6,11H4V9H6V11M6,7H4V5H6V7M10,19H8V17H10V19M10,15H8V13H10V15M10,11H8V9H10V11M10,7H8V5H10V7M20,19H12V17H20V19M20,15H12V13H20V15M20,11H12V9H20V11Z"/>
              </svg>
              <span class="nav-text">Arquitetura de Negócio_</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>          
          <li>
            <router-link 
              to="/architecture/application-old" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M4,1H20A1,1 0 0,1 21,2V6A1,1 0 0,1 20,7H4A1,1 0 0,1 3,6V2A1,1 0 0,1 4,1M4,9H20A1,1 0 0,1 21,10V14A1,1 0 0,1 20,15H4A1,1 0 0,1 3,14V10A1,1 0 0,1 4,9M4,17H20A1,1 0 0,1 21,18V22A1,1 0 0,1 20,23H4A1,1 0 0,1 3,22V18A1,1 0 0,1 4,17Z"/>
              </svg>
              <span class="nav-text">Arquitetura de Aplicação</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
          <li>
            <router-link 
              to="/architecture/application" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M4,1H20A1,1 0 0,1 21,2V6A1,1 0 0,1 20,7H4A1,1 0 0,1 3,6V2A1,1 0 0,1 4,1M4,9H20A1,1 0 0,1 21,10V14A1,1 0 0,1 20,15H4A1,1 0 0,1 3,14V10A1,1 0 0,1 4,9M4,17H20A1,1 0 0,1 21,18V22A1,1 0 0,1 20,23H4A1,1 0 0,1 3,22V18A1,1 0 0,1 4,17Z"/>
              </svg>
              <span class="nav-text">Arquitetura de Aplicação_</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>          
          <li>
            <router-link 
              to="/architecture/technology" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M4,6H20V16H4M20,18A2,2 0 0,0 22,16V6C22,4.89 21.1,4 20,4H4C2.89,4 2,4.89 2,6V16A2,2 0 0,0 4,18H0V20H24V18H20Z"/>
              </svg>
              <span class="nav-text">Arquitetura de Tecnologia</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="nav-section" v-if="isAllowed('tools.swagger') || isAllowed('tools.codegen')">
        <h3 class="nav-section-title">Ferramentas</h3>
        <ul class="nav-list">
          <li v-if="isAllowed('tools.swagger')">
            <router-link 
              to="/swagger-editor" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.06 9.02l.92.92L9.06 15.96l-3.75 1.85 1.85-3.75 5.9-5.04zM17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"/>
              </svg>
              <span class="nav-text">Editor Swagger</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>
          <li v-if="isAllowed('tools.codegen')">
            <router-link 
              to="/code-generator" 
              class="nav-link"
              active-class="nav-link-active"
            >
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0L19.2 12l-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
              </svg>
              <span class="nav-text">Gerador de Código</span>
              <div class="nav-indicator"></div>
            </router-link>
          </li>

        </ul>
      </div>


      
      -->
    </nav>

    <div class="sidebar-footer">
      <div class="user-info">
        <div class="user-avatar">
          <svg fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L12 2L3 7V9H21M3 19C3 19.6 3.4 20 4 20H20C20.6 20 21 19.6 21 19V11H3V19Z"/>
          </svg>
        </div>
        <div class="user-details">
          <span class="user-name">{{ authStore.user?.name || authStore.user?.email || 'Usuário' }}</span>
          <span class="user-role">{{ getUserRole() }}</span>
        </div>
      </div>
      <button @click="authStore.logout" class="logout-btn" title="Sair">
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
        </svg>
      </button>
    </div>
  </aside>
</template>

<script setup lang="ts">
defineOptions({ name: 'AppSidebar' })
import { computed } from 'vue'
import { useAuthStore } from '../../stores/auth'
import { SIDEBAR_ACCESS_BY_GROUP, DEFAULT_ACCESS } from '../../config/sidebarPermissions'
import type { SidebarItemId } from '../../config/sidebarPermissions'

const authStore = useAuthStore()

const getUserRole = () => {
  const roles = authStore.user?.roles || []
  const normalized = roles.map(r => (typeof r === 'string' ? r.toLowerCase() : r))
  if (normalized.includes('internal')) return 'Interno'
  if (normalized.includes('external')) return 'Externo'
  return 'Usuário'
}

const primaryGroup = computed(() => {
  const roles = (authStore.user?.roles || []).map(r => String(r).toLowerCase())
  if (roles.includes('internal')) return 'internal'
  if (roles.includes('external')) return 'external'
  return null
})

const allowedItemIds = computed(() => {
  if (primaryGroup.value) return SIDEBAR_ACCESS_BY_GROUP[primaryGroup.value]
  return DEFAULT_ACCESS
})

const allowedSet = computed(() => new Set(allowedItemIds.value))

const isAllowed = (id: SidebarItemId) => allowedSet.value.has(id)
</script>